import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/en-ca';

moment.lang('en-ca', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.en-ca.js